import React from 'react';
import { Box, Typography, Divider, Chip, Paper } from '@mui/material';
import { Questionnaire, Question } from '../../types/questionnaire';
import { InputView } from './viewRenderers/InputView';
import { OptionsView } from './viewRenderers/OptionsView';

interface QuestionnaireViewerProps {
  questionnaire: Questionnaire;
}

const getQuestionView = (question: Question) => {
  switch (question.component) {
    case 'select':
    case 'radio':
    case 'checkbox-group':
      return <OptionsView key={question.id} question={question} />;
    case 'input':
    case 'textarea':
      return <InputView key={question.id} question={question} />;
    default:
      return (
        <Paper key={question.id} sx={{ p: 2, mb: 2, backgroundColor: '#f5f5f5' }} variant="outlined">
          <Typography variant="body2" color="text.secondary">
            Відображення для компонента <strong>'{question.component}'</strong> ще не реалізовано.
          </Typography>
        </Paper>
      );
  }
};

export const QuestionnaireViewer: React.FC<QuestionnaireViewerProps> = ({ questionnaire }) => {
  return (
    <Box>
      {questionnaire.steps?.map((step, index) => (
        <Box key={step.id} sx={{ mb: 4 }}>
          <Divider sx={{ mb: 3, mt: 3 }}>
            <Chip label={`Крок ${index + 1}: ${step.caption}`} />
          </Divider>
          {step.description && (
            <Typography variant="body1" color="text.secondary" sx={{ mb: 3 }}>
              {step.description}
            </Typography>
          )}
          {step.questions.map(question => getQuestionView(question))}
        </Box>
      ))}
    </Box>
  );
};
